import React from 'react';
import { useTranslation } from 'react-i18next';

function CheckboxLabelControl() {
  const { t } = useTranslation('common');

  return (
    <>
      <div className="checkbox-label">
        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
        <label htmlFor="vehicle1" className="chklabel">
          <span>{t('CHECK_BOX_LABEL.I AGREE')}</span>
        </label>
      </div>
      <h6 className="mt-3">New Checkbox</h6>
      <div className="common-checkbox bold my-2">
        <input type="checkbox" id="check1" name="demo" value="demo" />
        <label htmlFor="check1" className="chklabel">
          <span>Mark as Complete</span>
        </label>
      </div>

      <div className="common-checkbox my-2">
        <input type="checkbox" id="check111" name="demo" value="demo" />
        <label htmlFor="check111" className="chklabel">
          <span>{t('CHECK_BOX_LABEL.I AGREE')}</span>
        </label>
      </div>

      <div className="common-checkbox">
        <input type="checkbox" id="check222" name="demo 1" value="demo 1" />
        <label htmlFor="check222" className="chklabel">
          <span className="sr-only">{t('CHECK_BOX_LABEL.I AGREE')}</span>
        </label>
      </div>
    </>
  );
}

export default CheckboxLabelControl;
